import { PopupTemplateComponent } from './popup-template.component';

export const PopupTemplateModule = angular
  .module('sfMobile.components.popup-template', [])
  .component('sfPopupTemplate', PopupTemplateComponent).name;
